import { User } from '../../../pages/common/History/interfaces';
import api from '../../api/api';

export const fetchDocumentData = async (document: string) => {
  const { data } = await api.get<User>('/users', {
    params: {
      document,
    },
  });
  return data;
};
